<template>
  <div>
    <div class="infotit infotitbg1">领先产品<span>LEADING PRODUCTS</span></div>
    <div class="mainInfoOut">
      <span class="topleft"></span>
      <div class="mainData">
        <div>
          <span class="leftLine"></span>
        </div>
        <div class="rightView">
          <div class="boxes" :class="{'noneTab': item.noneTab, 'subTit': item.subTit}" v-for="(item, index) in infoBox" :key="index" @click="popupClick(item.tit)">
            {{ item.nameNew || item.tit}}
            <div v-if="item.subTit" class="subTit">{{ item.subTit }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      infoBox: [
        {tit: 'MA码+链+AI技术',subTit: '集团资产全要素数智化平台'},
        {tit: '社会稳定风险防控治理体系'},
        {tit: '政府监管燃气安全数智化工程', },
        // {tit: '诈骗检测处置系统', nameNew: '电信网络诈骗防范与拦截系统' },
        {tit: '社会重点人员动态管控', },
      ]
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    popupClick(item) {
      let isJupm = true
      switch (item) {
        case '社会稳定风险防控治理体系':
          this.$emit('popupData', item)
          isJupm = false
          break;
      }
      isJupm ? this.navigator({name: 'detail', query: {title: item}}) : ''
    },
  },
  destroyed() {
  }
};
</script>

<style lang="less" scoped>
.mainInfoOut{
  width: 341px;
  min-height: 312px;
  margin: 0 auto;
  margin-top: 21px;
  position: relative;
  //background-color: #091a2e58;
  background-image: url("~@/image/popupBg.png");
  background-size: 100% 100%;
  padding-top: 32px;
  padding-left: 22px;
  padding-bottom: 22px;
  box-sizing: border-box;
  .topleft{
    position: absolute;
    width: 24px;
    height: 23px;
    left: 0;
    top: -1px;
    display: block;
    background-image: url("~@/image/paragraphBgAngle.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .mainData{
    display: grid;
    grid-template-columns: 19px 261px;
    grid-gap: 11px;
    >div{
      .leftLine{
        display: block;
        width: 1px;
        box-sizing: border-box;
        height: 88%;
        background-color: #ffffff;
        margin: 0 auto;
        margin-top: 8px;
      }
    }
    .rightView{
      .boxes{
        //margin-top: 29px;
        width: 261px;
        height: 36px;
        background-image: url("~@/image/paragraphTabBG.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        //text-indent: 5px;
        padding-left: 5px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        margin-bottom: 36px;
        &::before{
          width: 19px;
          height: 23px;
          position: absolute;
          content: "";
          top: -23px;
          left: -30px;
          top: 8px;
          background-image: url("~@/image/localIcon.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        &::after{
          width: 20px;
          height: 20px;
          position: absolute;
          content: "";
          right: -9px;
          top: 8px;
          background-image: url("~@/image/arrows.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        &:nth-last-of-type(1) {
          margin-bottom: 0;
        }
        &.subTit{
          display: block;
          height: 50px;
        }
      }
    }

    .noneTab{
      &::after{
        width: 20px;
        height: 20px;
        position: absolute;
        content: "";
        display: none;
        right: -9px;
        top: 8px;
        background-image: url("~@/image/arrows.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
